module.exports = __webpack_public_path__ + "assets/retina_CTranslateCircleDetailed.2d513072643bda91a1e71ff18b521ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CTranslateCircleDetailed.png
// module id = 630
// module chunks = 0